export const getItemCount = (cart) => {
  let itemCount = 0;

  if (cart?.items) {
    itemCount = cart.items.reduce((total, item) => total + item.quantity, 0);
  }
  return itemCount;
};
